<template>
  <!-- 添加图片 -->
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c flexJc-sb">
        <div class="text">{{ headText }}</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="content flex flexAi-c">
        <el-form
          :rules="rules"
          size="small"
          ref="bannerForm"
          :model="bannerForm"
          label-width="80px"
        >
          <el-form-item label="图片名称" prop="bannername">
            <el-input v-model="bannerForm.bannername"></el-input>
          </el-form-item>
          <el-form-item label="商品图片" prop="bannerimg">
            <div class="image">
              <el-upload
                action="#"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :file-list="fileList"
                :on-remove="handleRemove"
                :limit="1"
                :http-request="uploadSectionFile"
                :on-exceed="handleExceed"
              >
                <div class="addimage flex flexColumn flexAi-c flexJc-c">
                  <el-image
                    class="image flex"
                    :src="require('@/assets/ProductManage/tjtp.png')"
                  ></el-image>
                  <span class="text">添加图片</span>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="跳转路径">
            <el-input v-model="bannerForm.url"></el-input>
          </el-form-item>
          <el-form-item label="所属分类" prop="place">
            <el-select v-model="bannerForm.place" placeholder="请选择所属分类">
              <el-option label="首页banner" :value="1"></el-option>
              <el-option label="首页中间banner" :value="2"></el-option>
              <el-option label="智慧健身banner" :value="21"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片状态" prop="status">
            <el-radio-group v-model="bannerForm.status">
              <el-radio :label="0">可用</el-radio>
              <el-radio :label="1">不可用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('bannerForm')"
              >确定</el-button
            >
            <el-button @click="goBack">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUploadByBase64 } from '@/api/uploading'
import { apiAddBBanner, apiEditBBanner } from '@/api/InfoUpload'

let _self
export default {
  name: '',
  props: [''],

  data() {
    return {
      editObj: '', // 编辑的数据
      headText: '添加图片',
      uploadActionUrl: '',
      bannerForm: {
        bannername: '',
        bannerimg: '',
        url: '',
        place: 1,
        status: 0 // 1为停用
      },
      fileList: [], // 存储图片
      canworktime: [], // 工作时间
      rules: {
        bannername: [
          { required: true, message: '请输入图片名', trigger: 'blur' }
        ],
        bannerimg: [{ required: true, message: '请输入图片', trigger: 'blur' }],
        url: [{ required: true, message: '请输入产品库存', trigger: 'blur' }],
        place: [{ required: true, message: '请选择所属分类', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      dialogVisible: false
    }
  },
  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    if (this.$route.query.info !== undefined) {
      this.headText = '编辑图片'
      this.editObj = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.editObj)
      this.bannerForm.place = this.editObj.place
      this.bannerForm.bannername = this.editObj.bannername
      this.bannerForm.status = this.editObj.status
      this.bannerForm.url = this.editObj.url
      this.bannerForm.bannerimg = this.editObj.bannerimg
      if (this.editObj.bannerimg !== null) {
        _self.fileList = [{ url: this.baseImage + this.editObj.bannerimg }]
      }
      console.log(this.fileList)
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    addimageBut() {
      alert('1111')
    },
    /**
     * 文件上传-自定义上传行为
     * */
    uploadSectionFile(params, file1) {
      if (_self.fileList.length > 0) {
        this.$message.error('最高可上传一个图片')
        return
      }
      const file = params.file
      const fileType = file.type
      const isImage = fileType.indexOf('image') !== -1
      const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      if (!isImage) {
        this.$message.error('只能上传图片格式png、jpg、gif!')
        return
      }
      if (!isLt2M) {
        this.$message.error('只能上传图片大小小于2M')
        return
      }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function() {
        // const _self = this
        // this.result // 这个就是base64编码了
        const imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: imageUrl,
          path: 'serviceStaff'
        }).then(res => {
          if (res.status === 0) {
            _self.$message({
              message: '图片上传成功',
              type: 'success'
            })
            const list = {
              url: _self.baseImage + res.data
            }
            _self.bannerForm.bannerimg = res.data
            _self.fileList[0] = list
          }
        })
      }
    },
    // 删除文件之前的钩子
    handleRemove() {
      _self.fileList = []
      this.bannerForm.bannerimg = ''
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      this.$message.error('最高可上传一个图片')
    },

    // 取消按钮
    cancelBut() {
      // 返回上一页
      this.$router.go(-1)
    },
    // 按钮
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 不为空走编辑
          if (this.editObj !== '') {
            apiEditBBanner({
              id: this.editObj.id,
              bannername: this.bannerForm.bannername,
              bannerimg: this.bannerForm.bannerimg,
              url: this.bannerForm.url,
              place: this.bannerForm.place,
              status: this.bannerForm.status
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.bannerForm = {
                  bannername: '',
                  bannerimg: '',
                  url: '',
                  place: 1,
                  status: 0 // 1为服务人员
                }
                this.fileList = []
                this.$router.go(-1)
              } else if (res.status === 1) {
                this.$Me(res.msg)
              }
            })
          } else {
            apiAddBBanner({
              bannername: this.bannerForm.bannername,
              bannerimg: this.bannerForm.bannerimg,
              url: this.bannerForm.url,
              place: this.bannerForm.place,
              status: this.bannerForm.status
            }).then(res => {
              if (res.status === 0) {
                this.$Ms(res.msg)
                this.bannerForm = {
                  bannername: '',
                  bannerimg: '',
                  url: '',
                  place: 1,
                  status: 0 // 1为服务人员
                }
                this.$router.go(-1)
                this.fileList = []
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    background: #fff;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-form {
      width: 60%;
      /deep/ .el-form-item__content {
        .el-select {
          width: 100%;
          input {
            text-align: left;
          }
        }
        .addimage {
          height: 100%;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .el-image {
            width: 30px;
            height: 30px;
          }
          .text {
            padding: 0;
            padding-top: 10px;
            width: 100%;
            line-height: normal;
          }
        }
      }
    }
  }
}
</style>
